import {Model} from 'vue-mc';
import * as dateMethods from "@/helpers/date-methods";

export class BitacoraModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      usuario_username : ""
      , fecha_inicio : dateMethods.getDate()
      , fecha_fin : dateMethods.getDate()
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      usuario_username:usuario_username=>usuario_username
      , fechaInicio:fecha_inicio=>fecha_inicio
      , fechaFin:fecha_fin=>fecha_fin
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

  // Route configuration
  /*routes() {
    return {
      fetch: '/task/{id}'
    }
  }*/

}


// WEBPACK FOOTER //
// ./src/models/bitacoras/bitacora.js